export default __webpack_public_path__ + "static/media/3_tutorial_motion_primitive_generator.df3ba20c.png";